import { CategoryDto, CategoryDtoImpl } from '../categories/categorydto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';

export class SignupCategoriesBuilder
{
    constructor(private signupCategoriesList: any)
    {
        if(signupCategoriesList.appSettings === undefined)
        {
            throw new NoDataException("Categories Json data doesnt exists");
        }
    }

    buildAll(): CategoryDto[]
    {
        return this.parseSignupCategoriesResponse();
    }
    
    private parseSignupCategoriesResponse(): CategoryDto[]
    {
        let listOfSignupCategories: CategoryDto[] = [];
        
        let signupCategoriesDto = null;
        this.signupCategoriesList.appSettings.categories.forEach((signupCategoriesItem: any) =>
        {
            signupCategoriesDto = new CategoryDtoImpl();
            signupCategoriesDto.setId(signupCategoriesItem.id);
            signupCategoriesDto.setTitle(signupCategoriesItem.name);
            // signupCategoriesDto.set(signupCategoriesItem.nameAR);
            signupCategoriesDto.setImgPath(signupCategoriesItem.imageUrl);

            listOfSignupCategories.push(signupCategoriesDto);
        });
        return listOfSignupCategories;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/signupcategories/signupcategoriesbuilder.ts